type TraxiRuntimeConfig = {
  apiUrl?: string
  mapApiKey?: string
  pusherAppId?: string
  pusherKey?: string
  pusherCluster?: string
  isDev?: boolean
}

declare global {
  interface Window {
    __TRAXI_CONFIG__?: TraxiRuntimeConfig
  }
}

const runtime = typeof window === 'undefined' ? {} : window.__TRAXI_CONFIG__ || {}

export default {
  API_URL: runtime.apiUrl || '',
  MAP_API_KEY: runtime.mapApiKey || '',
  IS_DEV: runtime.isDev === true,
  PUSHER_APP_ID: runtime.pusherAppId || '',
  PUSHER_KEY: runtime.pusherKey || '',
  PUSHER_CLUSTER: runtime.pusherCluster || '',
}
